// Common utils

// Join dog names
export const getDogNames = (dogs: any) => {
  if (dogs && dogs.length > 0)
    return dogs
      .filter(d => d.name)
      .map(d => d.name)
      .join(', ')
      .replace(/,(?!.*,)/gim, ' &')
}

// Gtags
export const triggerTagging = (eventName: string, page: string, value?: any) => {
  if (typeof window.gtag !== 'undefined') {
    if (value) {
      window.gtag('event', eventName, {
        page: page,
        value: value
      })
    }
    window.gtag('event', eventName, {
      page: page
    })
  }
}
